import { useGameState } from '@/hooks/useGameState'

/** After playing: one button that switches the board to whichever play it isn't showing. */
export function PlayToggle({ className = '' }: { className?: string }) {
  const view = useGameState((s) => s.view)
  const setView = useGameState((s) => s.setView)
  return (
    <button type="button" onClick={() => setView(view === 'mine' ? 'top' : 'mine')} className={`btn-secondary ${className}`}>
      {view === 'mine' ? 'Show top play' : 'Show your play'}
    </button>
  )
}
